<template>
  <div class="mb-4">
    <div class="adjustment-separator">
      <div class="adjustment-separator__line" />
      <div
        class="adjustment-separator__applied"
        :class="{
          'adjustment-separator__applied--selected': selectedIndex === 0,
        }"
        @click="handleGetAppliedAdjustments"
      >
        <span>Ajustes Aplicados</span>
      </div>
      <div
        class="adjustment-separator__recommended"
        :class="{
          'adjustment-separator__recommended--selected': selectedIndex === 1,
        }"
        @click="handleGetRecommendedAdjustments"
      >
        <span>Ajuste Recomendado</span>
      </div>
      <div class="adjustment-separator__line" />
    </div>
    <div>
      <custom-callout
        v-for="(item, index) in adjustments"
        :id="`recommended-adjustment-${index}`"
        :key="index"
        :border-color-hex="isAppliedSelected ? '#B5C3BC' : '#F8B184'"
        class="ml-3 mt-3 mb-3 pr-2"
        :class="{
          'applied-callout': isAppliedSelected,
          'recommended-callout': isRecommendedSelected,
        }"
        :class-main="{
          'applied-callout': isAppliedSelected,
          'recommended-callout': isRecommendedSelected,
        }"
        :has-toggle="false"
      >
        <div>
          <div class="row mt-2">
            <div class="col">
              <span class="data-title d-block border-mobile">Nivel:</span>
              <p class="font-16">
                {{
                  item.transactionTypeId === levels.summary
                    ? 'Resumen'
                    : 'Visita'
                }}
              </p>
            </div>
            <!-- <div class="col col-sm col-12">
              <span class="data-title d-block border-mobile">Razón(es):</span>
              <p class="font-16">
                {{ item.adjustmentReason }}
              </p>
            </div> -->
            <div class="col col-sm col-12">
              <span class="data-title d-block border-mobile">Generado:</span>
              <p class="font-16">
                {{ item.generatedBy ?? '-' }}
              </p>
            </div>
            <div class="col col-sm col-12">
              <span class="data-title d-block border-mobile">
                Cantidad:
              </span>
              <p class="font-16">{{ formatCurrency(item.amount) }}</p>
            </div>
            <div v-if="isRecommendedSelected" class="col col-sm col-12">
              <span class="data-title d-block border-mobile">Estatus:</span>
              <p class="font-16 d-flex align-items-center">
                <em
                  v-if="itemHasBeenAcceptedOrRejected(item)"
                  class="fa fa-circle font-12 mr-1"
                  :class="recommendedStatusColor(item)"
                />
                <span
                  :class="{
                    'color-black-1 fw-bold': recommendedStatusColor(item),
                  }"
                >
                  {{ recommendedStatusName(item) }}
                </span>
              </p>
            </div>
            <div
              class="col col-sm col-12 d-flex justify-content-end align-items-end"
            >
              <div v-if="isAppliedSelected">
                <action-button
                  id="btn-reject"
                  i="fas fa-times-circle pl-2"
                  text="Eliminar"
                  variant="outline-danger mr-2 mb-4 pr-3"
                  @click="$emit('delete', { ...item })"
                />
              </div>
              <div
                v-if="
                  isRecommendedSelected && !itemHasBeenAcceptedOrRejected(item)
                "
                class="d-flex flex-row align-items-end justify-content-end"
              >
                <action-button
                  id="btn-reject"
                  i="fas fa-times-circle pl-2"
                  text="Rechazar"
                  variant="outline-danger mr-2 mb-4 pr-3"
                  @click="$emit('reject', { ...item })"
                />
                <action-button
                  id="btn-accept"
                  i="fas fa-check-circle pl-2"
                  text="Aceptar"
                  variant="success mb-4 pr-3 pl-2"
                  @click="$emit('accept', { ...item })"
                />
              </div>
              <div v-if="isRecommendedSelected && itemHasBeenRejected(item)">
                <action-button
                  id="btn-reject"
                  i="fas fa-times-circle pl-2"
                  text="Revertir Rechazo"
                  variant="outline-danger mr-2 mb-4 pr-3"
                  @click="$emit('revert-rejected', { ...item })"
                />
              </div>
            </div>
          </div>
          <hr class="my-0" />
          <div class="row mt-2">
            <div class="col">
              <div class="d-flex align-items-start">
                <div>
                  <span class="data-title d-block border-mobile">
                    Razón(es):
                  </span>
                  <p class="font-16">
                    {{ item.adjustmentReason }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <div class="d-flex align-items-start">
                <img
                  v-if="isRecommendedSelected"
                  alt="stars-icon"
                  class="mt-1"
                  src="@/assets/img/stars.svg"
                  style="height: 25px;"
                />
                <div
                  :class="{
                    'ml-3': isRecommendedSelected,
                  }"
                >
                  <span class="data-title d-block border-mobile">
                    Comentario de ajuste recomendado:
                  </span>
                  <p class="font-16">
                    {{ item.comment }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </custom-callout>
      <custom-result-not-found
        v-if="!adjustments.length"
        :text="'No hay información disponible.'"
      />
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomResultNotFound from 'custom-result-not-found';

// utils
import billingLevels from '@/utils/constants/billingLevels.js';
import rpAIAdjustmentRecommendationStatus from '@/utils/constants/rpAIAdjustmentRecommendationStatus.js';

export default {
  name: 'AdjustmentSeparated',
  components: {
    CustomCallout,
    ActionButton,
    CustomResultNotFound,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    selectedIndex: 0,
  }),
  computed: {
    levels() {
      return billingLevels;
    },
    isAppliedSelected() {
      return this.selectedIndex === 0;
    },
    isRecommendedSelected() {
      return this.selectedIndex === 1;
    },
    adjustments() {
      return this.selectedIndex === 0
        ? this.data.appliedAdjustments
        : this.data.recommendedAdjustments;
    },
    recommendedStatusName() {
      return (item) => {
        return {
          [rpAIAdjustmentRecommendationStatus.Accepted]: 'Aceptado',
          [rpAIAdjustmentRecommendationStatus.Rejected]: 'Rechazado',
          [rpAIAdjustmentRecommendationStatus.Unset]: '-',
        }[
          item.adjustmentRecommendationStatusId ??
            rpAIAdjustmentRecommendationStatus.Unset
        ];
      };
    },
    recommendedStatusColor() {
      return (item) => {
        return {
          [rpAIAdjustmentRecommendationStatus.Accepted]: 'color-green-light-2',
          [rpAIAdjustmentRecommendationStatus.Rejected]: 'color-primary-3',
          [rpAIAdjustmentRecommendationStatus.Unset]: '',
        }[
          item.adjustmentRecommendationStatusId ??
            rpAIAdjustmentRecommendationStatus.Unset
        ];
      };
    },
    itemHasBeenAcceptedOrRejected() {
      return (item) =>
        [
          rpAIAdjustmentRecommendationStatus.Accepted,
          rpAIAdjustmentRecommendationStatus.Rejected,
        ].includes(item.adjustmentRecommendationStatusId);
    },
    itemHasBeenRejected() {
      return (item) =>
        item.adjustmentRecommendationStatusId ===
        rpAIAdjustmentRecommendationStatus.Rejected;
    },
  },
  methods: {
    setSelectedIndex(index) {
      this.selectedIndex = index;
      this.$emit('selected', index);
    },
    handleGetAppliedAdjustments() {
      this.setSelectedIndex(0);
    },
    handleGetRecommendedAdjustments() {
      this.setSelectedIndex(1);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
$border-separator-radius: 50px;

.adjustment-separator {
  display: flex;
  align-items: center;
  justify-content: center;

  &__line {
    width: 100%;
    height: 1px;
    background: map-get($colors, 'gray-5');
    margin: 20px;
  }

  &__applied,
  &__recommended {
    min-width: 20%;
    background: map-get($colors, 'gray-5');
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    span {
      color: map-get($colors, 'gray-6');
      user-select: none;
    }
    &--selected {
      background: map-get($colors, 'gray-7');
      span {
        color: map-get($colors, 'white');
      }
    }
  }

  &__applied {
    border-radius: $border-separator-radius 0 0 $border-separator-radius;
  }
  &__recommended {
    border-radius: 0 $border-separator-radius $border-separator-radius 0;
  }
}

.applied-callout,
.recommended-callout :deep(.applied-callout, .recommended-callout) {
  .row {
    .col-12 {
      &:first-child {
        margin-left: -20px !important;
      }
    }
  }
}

.applied-callout :deep(.applied-callout) {
  background: map-get($colors, 'secondary-3');
  #btn-reject {
    background: transparent !important;
    &:hover {
      background: map-get($colors, 'primary-3') !important;
    }
  }
}

.recommended-callout :deep(.recommended-callout) {
  background: map-get($colors, 'secondary-18');
  #btn-reject {
    background: transparent !important;
    &:hover {
      background: map-get($colors, 'primary-3') !important;
    }
  }
}
</style>
